import * as React from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

import { qualities } from "./data";
import QualityCard from "./quality-card";

/**
 * Renders the qualities section
 * Shows all the qualities
 */
const Qualities = () => {
  const headingRef = React.useRef<HTMLHeadingElement>(null);

  useGSAP(() => {
    gsap.fromTo(
      headingRef.current,
      { y: "100%" },
      {
        y: 0,
        duration: 1.5,
        delay: 0.075,
        ease: "power4",
        scrollTrigger: {
          trigger: headingRef.current,
          start: "top 85%",
        },
      }
    );
  }, []);

  const containerStyles = `
    2xl:max-w-8xl 3xl:max-w-9xl 4xl:max-w-10xl 5xl:max-w-11xl relative z-20 mx-auto flex w-full max-w-full cursor-default flex-col items-center justify-end py-32 sm:max-w-[40rem] md:max-w-[50rem] lg:max-w-[63rem] xl:max-w-[75rem]
  `;

  return (
    <section className={containerStyles}>
      <div className="xs:py-3 xs:h-auto mb-16 h-14 overflow-hidden text-center">
        <h1 className="work-heading leading-[1.2]" ref={headingRef}>
          I AM.
        </h1>
      </div>
      <div className="xs:px-10 flex w-full max-w-7xl flex-col justify-center gap-y-5 md:flex-row md:gap-x-5 md:px-5 xl:px-0">
        <div className="flex flex-col gap-y-5">
          {[...qualities].splice(0, 2).map((q) => (
            <QualityCard key={q.id} quality={q} />
          ))}
        </div>
        <div className="flex flex-col gap-y-5 md:mt-32">
          {[...qualities].splice(2, 4).map((q) => (
            <QualityCard key={q.id} quality={q} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Qualities;
